import classNames from "classnames";
import { graphql, Link, useStaticQuery } from "gatsby";
import React from "react";
import { MenuLink } from "../../../types/app";

export interface FooterProps {
  className?: string;
}

const Footer: React.FC<FooterProps> = ({ className }) => {
  const {
    allMetaLinksJson: { edges: metaLinks },
    site: {
      siteMetadata: { version },
    },
  } = useStaticQuery<QueryType>(query);

  return (
    <div className={classNames("w-full bg-red-accent", className)}>
      <div className="flex flex-col gap-y-4 justify-between py-8 md:flex-row container-7xl md:gap-y-0">
        <p className="text-sm text-white">
          <span>{`© ${new Date().getFullYear()} Psychotherapie Praxis Düsseldorf.`}</span>{" "}
          <span className="text-red-accent">{version || "1.0.0"}</span>
        </p>
        <nav className="flex flex-col gap-4 md:flex-row">
          {metaLinks.map((link: { node: MenuLink }) => (
            <Link
              key={link.node.link}
              to={link.node.link}
              className="text-sm text-white"
            >
              {link.node.name}
            </Link>
          ))}
        </nav>
      </div>
    </div>
  );
};

const query = graphql`
  query FooterQuery {
    allMetaLinksJson {
      edges {
        node {
          name
          link
        }
      }
    }
    site {
      siteMetadata {
        version
      }
    }
  }
`;

type QueryType = {
  allMetaLinksJson: {
    edges: {
      node: MenuLink;
    }[];
  };
  site: {
    siteMetadata: {
      version: string;
    };
  };
};

export default Footer;
